/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const StyleRemplissage = require('../types/StyleRemplissage')
const kernel = require('../kernel/kernel')
const CSurfaceAncetre = require('./CSurfaceAncetre')
module.exports = CSurface

/**
 * Classe ancêtre des surfaces définies par un bord.
 * @constructor
 * @extends CSurfaceAncetre
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
 * @param {CElementGraphique} bord : Le bord de la surface.
 * @returns {CSurface}
 */
function CSurface (listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
  if (arguments.length === 0) return; // Ajout version 4.9.9.4
  if (arguments.length === 1) CSurfaceAncetre.call(this, listeProprietaire);
  else {
    CSurfaceAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage);
    this.bord = bord;
  }
  this.pattern = null;
}
CSurface.prototype = new CSurfaceAncetre();
CSurface.prototype.constructor = CSurface;
CSurface.prototype.superClass = "CSurfaceAncetre";
CSurface.prototype.className = "CSurface";

CSurface.prototype.confonduAvec = function(p) {
  var res = CSurfaceAncetre.prototype.confonduAvec.call(this, p);
  if (!res) return false;
  res = res && (this.bord === p.bord);
  return res;
};
CSurface.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CSurfaceAncetre.prototype.dependDe.call(this, p) || this.bord.dependDe(p));
};
CSurface.prototype.dependDePourBoucle = function(p) {
  return (p === this) || this.bord.dependDePourBoucle(p);
};
CSurface.prototype.dependDePourCapture = function(p) {
  return (p === this) || this.bord.dependDePourCapture(p);
};
CSurface.prototype.positionne = function(infoRandom, dimfen) {
  this.existe = this.bord.existe;
};
// Spécial JavaScript : ne sera redéfini que pour CSurfaceDisque;
// Chaque surface bordée par une polyline devra définir creePoints()
CSurface.prototype.createg = function(svg, couleurFond, transparence) {
  var opacity,style,color;
  // color = this.couleur.rgb() Modifié version 4.9.9.4
  color = this.color;
  var pol = kernel.cens("polyline");
  switch (this.styleRemplissage) {
    case StyleRemplissage.quadrillagePleinTransp:
    case StyleRemplissage.quadrillagePlein:
      opacity = (this.styleRemplissage === StyleRemplissage.quadrillagePleinTransp) ? transparence : 1;
      style = "stroke:none;";
      style += "fill-opacity:"+opacity+";";
      style += "fill:"+color+";";
      pol.setAttribute("style", style);
      break;
     default :
      style = "stroke:none;"+"fill:url(#"+this.index+"mtg32pattern);";
      if (this.pattern === null) this.createPattern();
      pol.setAttribute("style", style);
  }
  pol.setAttribute("points", this.creePoints());
  // if (this.listeProprietaire != null) pol.setAttribute("id",this.id);
  pol.setAttribute("pointer-events", "none");
  return pol;
};
CSurface.prototype.trace = function(svg, couleurFond, transparence) {
  var g = this.createg(svg, couleurFond, transparence);
  g.setAttribute("id",this.id);
  svg.appendChild(g);
  this.g = g;
};
// Spécial JavaScript : Update se sera redéfini que pour CSurfaceDisque
CSurface.prototype.update = function(svg, couleurFond, transparence) {
  var oldg = this.g;
  var g = this.createg(svg, couleurFond, transparence);
  svg.replaceChild(g, oldg);
  g.setAttribute("id",this.id);
  this.g = g;
};
CSurface.prototype.read = function(inps, list){
  CSurfaceAncetre.prototype.read.call(this,inps, list);
  var ind1 = inps.readInt();
  this.bord = list.get(ind1,"CElementGraphique");
};
CSurface.prototype.write = function(oups, list){
  CSurfaceAncetre.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.bord);
  oups.writeInt(ind1);
};
// Spécifique JavaScript
CSurface.prototype.createPattern = function() {
  var svg,p,path,d;
  svg = document.getElementById(this.listeProprietaire.id);
  this.pattern = kernel.cens("defs");
  // pattern.setAttribute("id", this.id+"mtg32pattern");
  p = kernel.cens("pattern");
  path = kernel.cens("path");
  p.setAttribute("patternUnits","userSpaceOnUse");
  p.setAttribute("x","0");
  p.setAttribute("y","0");
  p.setAttribute("width","6");
  p.setAttribute("height","6");
  // var style="fill:none; stroke:"+this.couleur.rgb()+"; stroke-width:0.5;"; Modifié version 4.9.9.4
  var style="fill:none; stroke:"+this.color+"; stroke-width:0.5;";
  // p.setAttribute("style", style);
  switch (this.styleRemplissage){
    case StyleRemplissage.quadrillageHorizontal:
      d="M 0 3 L 6 3";
      break;
    case StyleRemplissage.quadrillageVertical:
      d="M 3 0 L 3 6";
      break;
    case StyleRemplissage.quadrillage45Bas:
      d="M 0 0 L 6 6";
      break;
    case StyleRemplissage.quadrillage45Haut:
      d="M 6 0 L 0 6";
      break;
    case StyleRemplissage.quadrillageCroise:
      d="M 0 0 L 6 6 M 6 0 L 0 6";
  }
  path.setAttribute("d", d);
  path.setAttribute("style", style);
  p.appendChild(path);
  p.setAttribute("id", this.index+"mtg32pattern");
  this.pattern.appendChild(p);
  svg.appendChild(this.pattern);
};



// WEBPACK FOOTER //
// ./src/objets/CSurface.js